import axiosClient from './axiosClient'
const citysApi = {
  getAll: (params) => {
    const url = '/city/getAll'
    return axiosClient.get(url, { params })
  },
}
export default citysApi
